// Mock data for empty leaderboard responses

export function getMockNovels() {
  return {
    content: [
      {
        id: 7,
        uuid: 'eef8076f-fe5d-41b4-9d5e-0c4a4d515c6e',
        title: 'Galaxy Wars',
        authorId: '550e8400-e29b-41d4-a716-446655440004',
        authorUsername: 'Space Writer',
        avgRating: 5.0,
        viewCnt: 3025,
        voteCnt: 84,
        coverImgUrl: null,
        categoryId: 4,
        categoryName: 'Sci-Fi',
        synopsis: 'An epic space opera about galactic conflicts and alien civilizations',
        isCompleted: false,
      },
      {
        id: 3,
        uuid: '0952b6c3-1fbb-4c7b-9772-f3a2e9624e3f',
        title: 'Love in Paris',
        authorId: '550e8400-e29b-41d4-a716-446655440002',
        authorUsername: 'Jane Romance',
        avgRating: 3.5,
        viewCnt: 2009,
        voteCnt: 60,
        coverImgUrl: null,
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: 'A heartwarming love story set in the romantic city of Paris',
        isCompleted: true,
      },
      {
        id: 1,
        uuid: '6e0b9a2f-2c36-43ae-995e-74ceee275c79',
        title: 'The Dragon Chronicles',
        authorId: '550e8400-e29b-41d4-a716-446655440001',
        authorUsername: 'John Fantasy',
        avgRating: 4.5,
        viewCnt: 1219,
        voteCnt: 55,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761355603212-1761355603769_61d9956f-c2f6-4bc4-9538-71cd21944209.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'An epic tale of dragons and magic in a mystical realm',
        isCompleted: true,
      },
      {
        id: 11,
        uuid: '8e13fbfc-24f9-4ee7-9399-1c0c8ff77916',
        title: 'Treasure Island',
        authorId: '550e8400-e29b-41d4-a716-446655440006',
        authorUsername: 'Adventure Writer',
        avgRating: 5.0,
        viewCnt: 1803,
        voteCnt: 50,
        coverImgUrl: null,
        categoryId: 6,
        categoryName: 'Adventure',
        synopsis: 'A classic adventure tale of pirates and hidden treasure',
        isCompleted: true,
      },
      {
        id: 5,
        uuid: '90da8e31-a6dc-450f-b8e3-af7047654b2a',
        title: 'The Missing Heir',
        authorId: '550e8400-e29b-41d4-a716-446655440003',
        authorUsername: 'Detective Smith',
        avgRating: 5.0,
        viewCnt: 1500,
        voteCnt: 40,
        coverImgUrl: null,
        categoryId: 3,
        categoryName: 'Mystery',
        synopsis: 'A detective investigates the mysterious disappearance of a wealthy heir',
        isCompleted: true,
      },
      {
        id: 15,
        uuid: '5f2fe21e-b57f-47de-a27f-ea2d3ab94ff7',
        title: 'The Office Comedy',
        authorId: '550e8400-e29b-41d4-a716-446655440008',
        authorUsername: 'Comedy Writer',
        avgRating: 4.2,
        viewCnt: 1302,
        voteCnt: 38,
        coverImgUrl: null,
        categoryId: 8,
        categoryName: 'Comedy',
        synopsis: 'A hilarious workplace comedy about office life',
        isCompleted: true,
      },
      {
        id: 13,
        uuid: '2074199b-7477-434b-98df-e5e41f3f5d98',
        title: 'Family Secrets',
        authorId: '550e8400-e29b-41d4-a716-446655440007',
        authorUsername: 'Drama Author',
        avgRating: 4.4,
        viewCnt: 1106,
        voteCnt: 38,
        coverImgUrl: null,
        categoryId: 7,
        categoryName: 'Drama',
        synopsis: 'A family drama exploring secrets and relationships',
        isCompleted: true,
      },
      {
        id: 2,
        uuid: '9ebc12a7-b548-4d14-ae16-d2d4aad62cb6',
        title: 'Mage Academy',
        authorId: '550e8400-e29b-41d4-a716-446655440001',
        authorUsername: 'John Fantasy',
        avgRating: 5.0,
        viewCnt: 802,
        voteCnt: 34,
        coverImgUrl: null,
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'A young mage discovers his powers at the prestigious academy',
        isCompleted: false,
      },
      {
        id: 9,
        uuid: '6eb03cbb-97e4-4a42-b6e3-c79f2c31ddc4',
        title: 'The Haunted Mansion',
        authorId: '550e8400-e29b-41d4-a716-446655440005',
        authorUsername: 'Horror Author',
        avgRating: 5.0,
        viewCnt: 903,
        voteCnt: 25,
        coverImgUrl: null,
        categoryId: 5,
        categoryName: 'Horror',
        synopsis: 'A terrifying tale of supernatural events in an old mansion',
        isCompleted: true,
      },
      {
        id: 33,
        uuid: 'e94f980e-8385-40b8-a2c3-a96200d355e6',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 4.0,
        viewCnt: 6,
        voteCnt: 3,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com//yushan-content/covers/novel-1761487703873-1761487704036_e3e9974a-4e1a-4536-a84a-6a81602fb554.jpeg',
        categoryId: 3,
        categoryName: 'Mystery',
        synopsis: '12',
        isCompleted: false,
      },
      {
        id: 30,
        uuid: 'a31175b0-967f-435f-a92c-234f314f774b',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 3,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761386857037-1761386857093_3e517cfe-56aa-4857-9067-7183f99b5458.jpeg',
        categoryId: 8,
        categoryName: 'Comedy',
        synopsis: 'comedy',
        isCompleted: false,
      },
      {
        id: 28,
        uuid: '210836c0-9b59-4618-9137-fd4c6d9e5102',
        title: 'string',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 2,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761381612287-1761381612411_cfe37c0e-cafd-41e0-b94b-5dabac70ff3d.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'string',
        isCompleted: true,
      },
      {
        id: 42,
        uuid: '12e32f36-1a7f-40bf-8c8f-8b0eec28d9ce',
        title: 'Maugus',
        authorId: '7f6824c7-f82c-44a9-b965-dc4d9bb9bd38',
        authorUsername: 'Maugus0',
        avgRating: 3.0,
        viewCnt: 15,
        voteCnt: 1,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761512168771-1761512168826_b0f4e9a6-c05d-4e6d-a9fa-91bafdc56ea7.jpeg',
        categoryId: 19,
        categoryName: 'Slice of Life',
        synopsis: 'Hello I am ahan',
        isCompleted: false,
      },
      {
        id: 45,
        uuid: 'ed411300-4119-4d5e-ac40-f7740284e4d7',
        title: 'The daughter of sea',
        authorId: 'ae384c3d-33d7-45e2-9bfa-442c0af50947',
        authorUsername: 'Ada',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761534620348-1761534620427_18c75191-3e44-4cc9-b52d-a2e82f588796.jpeg',
        categoryId: 14,
        categoryName: 'Eastern Fantasy',
        synopsis: 'The daughter of sea',
        isCompleted: false,
      },
      {
        id: 44,
        uuid: 'd211e00c-b515-42e4-9f5e-c71f18b56a0d',
        title: 'Lost man',
        authorId: 'b1cc3808-3b55-4f56-978f-a9b2b7f08d34',
        authorUsername: 'sherry',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761533765410-1761533765481_a005cda2-2b44-4bf9-95d3-b59c463d47e2.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'lost man',
        isCompleted: false,
      },
      {
        id: 43,
        uuid: 'b9b62092-8066-41e2-9fa0-9751527f82a5',
        title: '1231',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: '123123',
        isCompleted: true,
      },
      {
        id: 41,
        uuid: '35bda700-ab84-4cbe-8a44-bde9dfa61817',
        title: 'Maugus',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 2,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761512000094-1761512000188_25acf11a-edab-4679-8366-76d9d4d6f211.jpeg',
        categoryId: 19,
        categoryName: 'Slice of Life',
        synopsis: 'A great story told by Maugus',
        isCompleted: false,
      },
      {
        id: 40,
        uuid: '4a02a25c-e9a7-480e-811b-b59e7d9925de',
        title: 'Maugus',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761511997345-1761511997449_306f8081-48e7-4bd9-ac55-d0b6b6fdbcc5.jpeg',
        categoryId: 19,
        categoryName: 'Slice of Life',
        synopsis: 'A great story told by Maugus',
        isCompleted: false,
      },
      {
        id: 39,
        uuid: 'da8de7cb-7f22-454b-bbff-f098c2cfbd47',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761501483063-1761501483260_09a6d7e8-4dce-4683-8170-9a7d30971b25.jpeg',
        categoryId: 4,
        categoryName: 'Sci-Fi',
        synopsis: '1',
        isCompleted: false,
      },
      {
        id: 38,
        uuid: 'ba72a12c-8626-45e6-b33c-ff25f5c30667',
        title: '123123',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761500112373-1761500112486_5eda6783-e781-429f-b77c-4580ebc5e625.jpeg',
        categoryId: 4,
        categoryName: 'Sci-Fi',
        synopsis: '14223',
        isCompleted: true,
      },
      {
        id: 37,
        uuid: 'c8872b08-4c97-424b-a332-af3ada1317d6',
        title: '3123',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761500103433-1761500103582_01609de6-a2d7-4a74-8575-57eefbe2be76.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: '123',
        isCompleted: true,
      },
      {
        id: 36,
        uuid: 'b0126106-9267-4441-9503-8c00f32a619e',
        title: '3123',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://yushan-content.sgp1.cdn.digitaloceanspaces.com/covers/novel-1761499968025-1761499968776_976b1429-8a7c-4c4b-a242-73d7acb0996b.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: '123',
        isCompleted: true,
      },
      {
        id: 35,
        uuid: 'd0617b28-4d9f-412b-8673-d7b8518ab199',
        title: '3123',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761499448053-1761499448643_478c4978-3f9b-4106-be38-f8b48f432486.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: '123',
        isCompleted: true,
      },
      {
        id: 34,
        uuid: '5836ea73-dafc-4efd-ae11-5137f5e818a6',
        title: '3123',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com//yushan-content/covers/novel-1761497710500-1761497710609_7fd8c615-7ba9-4660-bb21-09506832ae3f.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: '123',
        isCompleted: true,
      },
      {
        id: 32,
        uuid: '6f968087-46d8-40a1-8f73-0f9e2d57866e',
        title: 'snowMan',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com//yushan-content/covers/novel-1761469794078-1761469794833_647ad98a-fa1d-4f32-b6c4-baff05812212.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'The snowman',
        isCompleted: false,
      },
      {
        id: 29,
        uuid: '3fcb8115-f590-4936-a1db-71bd37ff5f07',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761386805597-1761386805691_685bd488-1b62-4dc4-a411-51a3fc1790a4.jpeg',
        categoryId: 6,
        categoryName: 'Adventure',
        synopsis: 'adventure',
        isCompleted: false,
      },
      {
        id: 27,
        uuid: '18737167-d198-466b-9ecc-258d3905c92d',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 3.7,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761386124764-1761386125006_b7ada8d8-a158-49d2-ab74-2b5f9182fd28.jpeg',
        categoryId: 6,
        categoryName: 'Adventure',
        synopsis: '1',
        isCompleted: true,
      },
      {
        id: 26,
        uuid: '4c73f8f4-80a8-4301-857a-323f427a402b',
        title: 'The Lost Empire',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761381424822-1761381425034_d74fe448-5767-44b5-a8e6-09d54b94c37c.jpeg',
        categoryId: 6,
        categoryName: 'Adventure',
        synopsis: '1',
        isCompleted: false,
      },
      {
        id: 25,
        uuid: '60af0589-18ba-4aca-aedb-17048d1e4be8',
        title: 'Library',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761381234123-1761381234213_9a54e92c-e0ff-4d77-92ba-388eb1fe38ec.jpeg',
        categoryId: 7,
        categoryName: 'Drama',
        synopsis: 'library',
        isCompleted: false,
      },
      {
        id: 24,
        uuid: '8bec9108-794f-4b99-a0fd-8ddffc5d0a90',
        title: 'The Lost Empire1',
        authorId: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        authorUsername: 'yang',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761388453530-1761388453583_c479789d-fbbf-425f-860c-1c34e156450f.jpeg',
        categoryId: 5,
        categoryName: 'Horror',
        synopsis: 'horror',
        isCompleted: false,
      },
      {
        id: 23,
        uuid: 'b001452e-2e41-40d9-90a7-422c94bc4da0',
        title: 'Test Author Novel',
        authorId: '6fbdf3dc-0406-4b6e-a4d6-a1e1e56b70e2',
        authorUsername: 'p7OL1nVcYNXKXKXbbKZK',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'Test synopsis from author',
        isCompleted: false,
      },
      {
        id: 22,
        uuid: '9ed5dc26-33e4-408a-b777-a38dcc0f62bc',
        title: 'Test Novel',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin1',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'Test synopsis',
        isCompleted: false,
      },
      {
        id: 21,
        uuid: 'a0d6636f-f878-4ff0-9632-8a20dc890154',
        title: '312312',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin1',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761378723610-1761378723701_bc60dd66-eab3-4158-9184-33f0d3c559b8.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'string',
        isCompleted: true,
      },
      {
        id: 20,
        uuid: '6db91ba6-f10e-480c-a04e-805cbcccfa46',
        title: 'string',
        authorId: '550e8400-e29b-41d4-a716-446655440001',
        authorUsername: 'test_author',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761374345258-1761374345522_15ecc156-dbbf-46b9-95b4-707afc07e8fb.jpeg',
        categoryId: 1,
        categoryName: 'Fantasy',
        synopsis: 'string',
        isCompleted: true,
      },
      {
        id: 19,
        uuid: '13c4898b-aa71-4ac0-97ee-cefc7239d782',
        title: 'Misssing boy',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761372989404-1761372989618_bc7d6c59-e8d7-49c6-acca-649cd891775f.jpeg',
        categoryId: 4,
        categoryName: 'Sci-Fi',
        synopsis: 'drama',
        isCompleted: false,
      },
      {
        id: 18,
        uuid: '639ee722-79c9-4484-887d-467c5f48c433',
        title: 'The Lost Empire',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761372903635-1761372903789_3e1fb89f-10cc-4970-b87e-0c3f5352768c.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: 'romance story1',
        isCompleted: false,
      },
      {
        id: 17,
        uuid: '5b43ebf0-ec71-438b-b769-ca8a6eae0978',
        title: 'The Lost Empire',
        authorId: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        authorUsername: 'admin',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl:
          'https://sgp1.digitaloceanspaces.com/yushan-content/covers/novel-1761372885515-1761372885664_f611a9d1-f0b0-424d-9de5-7fb84a77a2c9.jpeg',
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: 'romance story',
        isCompleted: false,
      },
      {
        id: 8,
        uuid: '07000cc0-4fa5-42a9-9712-c4e31895eed8',
        title: 'Time Traveler',
        authorId: '550e8400-e29b-41d4-a716-446655440004',
        authorUsername: 'Space Writer',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 4,
        categoryName: 'Sci-Fi',
        synopsis: 'A scientist discovers the secret of time travel',
        isCompleted: false,
      },
      {
        id: 4,
        uuid: '139b9128-7264-4673-8ce1-981405dc43c6',
        title: 'Summer Romance',
        authorId: '550e8400-e29b-41d4-a716-446655440002',
        authorUsername: 'Jane Romance',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 2,
        categoryName: 'Romance',
        synopsis: 'A summer fling that turns into something more',
        isCompleted: false,
      },
      {
        id: 16,
        uuid: '851b678c-c49c-4953-b998-90919329557a',
        title: 'Funny Farm',
        authorId: '550e8400-e29b-41d4-a716-446655440008',
        authorUsername: 'Comedy Writer',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 8,
        categoryName: 'Comedy',
        synopsis: 'A comedy about life on a quirky farm',
        isCompleted: false,
      },
      {
        id: 12,
        uuid: 'd1673916-fc55-4b3a-9eea-cb1e65165645',
        title: 'Mountain Expedition',
        authorId: '550e8400-e29b-41d4-a716-446655440006',
        authorUsername: 'Adventure Writer',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 6,
        categoryName: 'Adventure',
        synopsis: "An expedition to climb the world's highest mountain",
        isCompleted: false,
      },
      {
        id: 10,
        uuid: '0b7b8572-acca-4044-83f2-811ddb4486e6',
        title: 'Nightmare Alley',
        authorId: '550e8400-e29b-41d4-a716-446655440005',
        authorUsername: 'Horror Author',
        avgRating: 5.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 5,
        categoryName: 'Horror',
        synopsis: 'A psychological horror story about nightmares coming to life',
        isCompleted: false,
      },
      {
        id: 14,
        uuid: '2643caa3-cc64-4cf6-958a-e460a38c753c',
        title: 'The Last Goodbye',
        authorId: '550e8400-e29b-41d4-a716-446655440007',
        authorUsername: 'Drama Author',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 7,
        categoryName: 'Drama',
        synopsis: 'A poignant story about saying goodbye to loved ones',
        isCompleted: false,
      },
      {
        id: 6,
        uuid: 'd3207559-205d-403d-b436-74ded8284238',
        title: 'Midnight Murder',
        authorId: '550e8400-e29b-41d4-a716-446655440003',
        authorUsername: 'Detective Smith',
        avgRating: 0.0,
        viewCnt: 0,
        voteCnt: 0,
        coverImgUrl: null,
        categoryId: 3,
        categoryName: 'Mystery',
        synopsis: 'A murder mystery that unfolds in the dead of night',
        isCompleted: false,
      },
    ],
    totalElements: 44,
    totalPages: 1,
    currentPage: 0,
    size: 50,
    first: true,
    last: true,
    hasNext: false,
    hasPrevious: false,
  };
}

export function getMockReaders() {
  return {
    content: [
      {
        uuid: 'bc440d0f-be02-4b25-a987-d79ad6430cf1',
        email: '123456123@yushan.com',
        username: 'yangshuang',
        avatarUrl: 'user_female.png',
        profileDetail: null,
        birthday: '2013-10-24',
        gender: 'FEMALE',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-27T02:57:15Z',
        updateTime: '2025-10-27T03:05:19Z',
        lastActive: '2025-10-27T03:05:19Z',
        lastLogin: '2025-10-27T02:57:15Z',
        level: 9,
        currentExp: 3200,
      },
      {
        uuid: 'b1cc3808-3b55-4f56-978f-a9b2b7f08d34',
        email: '123456@yushan.com',
        username: 'sherry',
        avatarUrl: 'user.png',
        profileDetail: null,
        birthday: '2013-10-08',
        gender: 'UNKNOWN',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-27T01:38:43Z',
        updateTime: '2025-10-27T02:55:15Z',
        lastActive: '2025-10-27T02:55:15Z',
        lastLogin: '2025-10-27T01:38:43Z',
        level: 9,
        currentExp: 3100,
      },
      {
        uuid: '7f6824c7-f82c-44a9-b965-dc4d9bb9bd38',
        email: 'ahanjaiswal12@gmail.com',
        username: 'Maugus0',
        avatarUrl: 'user_female.png',
        profileDetail: 'Hi I am ahan',
        birthday: '2013-10-17',
        gender: 'FEMALE',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-26T20:53:56Z',
        updateTime: '2025-10-27T03:09:19Z',
        lastActive: '2025-10-27T03:09:19Z',
        lastLogin: '2025-10-26T20:55:37Z',
        level: 9,
        currentExp: 3000,
      },
      {
        uuid: '8fa383e8-a761-4d54-9452-b3f716bbe934',
        email: 'phutruong1@gmail.com',
        username: 'yw6pkO1EWlOs7z54kN2j',
        avatarUrl: 'user.png',
        profileDetail: null,
        birthday: '2025-10-26',
        gender: 'UNKNOWN',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-26T18:26:25Z',
        updateTime: '2025-10-26T18:27:03Z',
        lastActive: '2025-10-26T18:26:49Z',
        lastLogin: '2025-10-26T18:26:25Z',
        level: 8,
        currentExp: 2100,
      },
      {
        uuid: 'bc106817-bcd9-444c-918e-6e81cd601b52',
        email: 'sherryy021229@gmail.com',
        username: 'Sun',
        avatarUrl: 'user_female.png',
        profileDetail: null,
        birthday: '2013-10-25',
        gender: 'FEMALE',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-26T18:06:47Z',
        updateTime: '2025-10-26T18:33:28Z',
        lastActive: '2025-10-26T18:33:02Z',
        lastLogin: '2025-10-26T18:06:47Z',
        level: 8,
        currentExp: 2000,
      },
      {
        uuid: 'ae384c3d-33d7-45e2-9bfa-442c0af50947',
        email: 'e1554266@u.nus.edu',
        username: 'Ada',
        avatarUrl: 'user_female.png',
        profileDetail: null,
        birthday: '2013-10-26',
        gender: 'FEMALE',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-25T16:46:34Z',
        updateTime: '2025-10-27T03:09:26Z',
        lastActive: '2025-10-27T03:09:26Z',
        lastLogin: '2025-10-27T03:09:26Z',
        level: 7,
        currentExp: 1700,
      },
      {
        uuid: '6fbdf3dc-0406-4b6e-a4d6-a1e1e56b70e2',
        email: '123456@example.com',
        username: 'p7OL1nVcYNXKXKXbbKZK',
        avatarUrl: 'user.png',
        profileDetail: null,
        birthday: '2025-10-25',
        gender: 'UNKNOWN',
        isAuthor: true,
        isAdmin: true,
        status: 'NORMAL',
        createTime: '2025-10-25T08:06:42Z',
        updateTime: '2025-10-26T01:28:26Z',
        lastActive: '2025-10-25T08:09:40Z',
        lastLogin: '2025-10-25T08:09:40Z',
        level: 7,
        currentExp: 1600,
      },
      {
        uuid: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        email: '2564436853@qq.com',
        username: 'yang',
        avatarUrl: 'user_female.png',
        profileDetail: null,
        birthday: '2013-10-08',
        gender: 'FEMALE',
        isAuthor: true,
        isAdmin: false,
        status: 'NORMAL',
        createTime: '2025-10-25T06:30:43Z',
        updateTime: '2025-10-27T00:43:15Z',
        lastActive: '2025-10-27T00:43:15Z',
        lastLogin: '2025-10-26T14:37:59Z',
        level: 7,
        currentExp: 1500,
      },
      {
        uuid: '72f0acc3-6c3c-49ad-b41f-d08991b421b9',
        email: 'quinn.murphy@hotmail.com',
        username: 'quinnmurphy',
        avatarUrl: 'user_female.png',
        profileDetail: 'Irish romance',
        birthday: '1994-07-06',
        gender: 'MALE',
        isAuthor: false,
        isAdmin: false,
        status: 'BANNED',
        createTime: '2025-10-25T01:10:09Z',
        updateTime: '2025-10-24T01:10:09Z',
        lastActive: '2025-10-25T01:10:09Z',
        lastLogin: '2025-10-24T01:10:09Z',
        level: 6,
        currentExp: 1100,
      },
      {
        uuid: '7137bdb8-3a3e-4d1c-86ce-0f0f950f1293',
        email: 'wendy.silva@gmail.com',
        username: 'wendysilva',
        avatarUrl: 'user_female.png',
        profileDetail: 'Brazilian romance',
        birthday: '1995-11-18',
        gender: 'MALE',
        isAuthor: false,
        isAdmin: false,
        status: 'BANNED',
        createTime: '2025-10-25T01:10:09Z',
        updateTime: '2025-10-24T01:10:09Z',
        lastActive: '2025-10-25T01:10:09Z',
        lastLogin: '2025-10-24T01:10:09Z',
        level: 6,
        currentExp: 1000,
      },
    ],
    totalElements: 135,
    totalPages: 3,
    currentPage: 0,
    size: 50,
    first: true,
    last: false,
    hasNext: true,
    hasPrevious: false,
  };
}

export function getMockWriters() {
  return {
    content: [
      {
        uuid: '550e8400-e29b-41d4-a716-446655440001',
        username: 'John Fantasy',
        avatarUrl: null,
        novelNum: 3,
        totalViewCnt: 2021,
        totalVoteCnt: 89,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440004',
        username: 'Space Writer',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 3025,
        totalVoteCnt: 84,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440002',
        username: 'Jane Romance',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 2009,
        totalVoteCnt: 60,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440006',
        username: 'Adventure Writer',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 1803,
        totalVoteCnt: 50,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440003',
        username: 'Detective Smith',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 1500,
        totalVoteCnt: 40,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440008',
        username: 'Comedy Writer',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 1302,
        totalVoteCnt: 38,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440007',
        username: 'Drama Author',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 1106,
        totalVoteCnt: 38,
      },
      {
        uuid: '550e8400-e29b-41d4-a716-446655440005',
        username: 'Horror Author',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 903,
        totalVoteCnt: 25,
      },
      {
        uuid: 'f3ad9e96-5d03-44fa-9e48-08cc8c546bc4',
        username: 'yang',
        avatarUrl: null,
        novelNum: 9,
        totalViewCnt: 6,
        totalVoteCnt: 8,
      },
      {
        uuid: '7f6824c7-f82c-44a9-b965-dc4d9bb9bd38',
        username: 'Maugus0',
        avatarUrl: null,
        novelNum: 1,
        totalViewCnt: 15,
        totalVoteCnt: 1,
      },
      {
        uuid: '5045b2cf-efc8-45de-ad6a-c7ef68e7db90',
        username: 'admin',
        avatarUrl: null,
        novelNum: 14,
        totalViewCnt: 2,
        totalVoteCnt: 0,
      },
      {
        uuid: '6fbdf3dc-0406-4b6e-a4d6-a1e1e56b70e2',
        username: 'p7OL1nVcYNXKXKXbbKZK',
        avatarUrl: null,
        novelNum: 1,
        totalViewCnt: 0,
        totalVoteCnt: 0,
      },
      {
        uuid: 'b1cc3808-3b55-4f56-978f-a9b2b7f08d34',
        username: 'sherry',
        avatarUrl: null,
        novelNum: 1,
        totalViewCnt: 0,
        totalVoteCnt: 0,
      },
      {
        uuid: 'ae384c3d-33d7-45e2-9bfa-442c0af50947',
        username: 'Ada',
        avatarUrl: null,
        novelNum: 2,
        totalViewCnt: 0,
        totalVoteCnt: 0,
      },
    ],
    totalElements: 14,
    totalPages: 1,
    currentPage: 0,
    size: 50,
    first: true,
    last: true,
    hasNext: false,
    hasPrevious: false,
  };
}
